import { Form, Input, Radio } from "antd";

// Disabled state is derived from the toggle field's own value (via
// Form.useWatch) rather than separate component state, so it stays correct
// when a form is pre-filled programmatically (e.g. edit mode) and not just
// when the user manually clicks the radio.
const RadioTextBoxField = ({ field, form, onRadioChange }) => {
  const toggleValue = Form.useWatch(`${field.name}_toggle`, form);
  const isDisabled = (toggleValue ?? "disable") === "disable";

  return (
    <div key={field.name}>
      <Form.Item
        hidden={field?.hidden}
        name={`${field.name}_toggle`}
        label={field.label}
        rules={field.rules}
        initialValue="disable"
      >
        <Radio.Group onChange={(e) => onRadioChange(field.name, e)}>
          <Radio value="enable">Input</Radio>
          <Radio value="disable">None</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name={field.name}
        extra={field.extra}
        rules={field.rules}
        style={{ marginBottom: 24 }}
      >
        <Input placeholder={field.placeholder} disabled={isDisabled} />
      </Form.Item>
    </div>
  );
};

export default RadioTextBoxField;
